export enum SkeletonTypes {
  BADGE = 'badge',
  CARD = 'card',
  HEADER = 'header',
  INITIALS = 'initials',
  TEXT = 'text',
  TIMELINE_INDICATOR = 'timeline-indicator',
  TITLE = 'title'
}
